import React from 'react';
import classnames from 'classnames';
import styles from 'v2/common/DRM/ListPages/emptyPlaceholder.module.scss';

interface StateProps {
  message: string;
}

const EmptyPlaceholder = ({ message }: StateProps) => {
  return (
    <div className="h-100 w-100 flex-column text-center mt-5">
      <div data-cy="search:search-placeholder">
        <h1 className={classnames(styles.noMatchTitle)}>No results found!</h1>
        <p className={classnames(styles.noMatchDescription)}>{message}</p>
      </div>
    </div>
  );
};

export default EmptyPlaceholder;
